import { httpService } from 'core-utilities';
import { Result } from '../../result';
import { toResult } from '../common';
import * as PromptAssignments from '../types/promptAssignments';
import { PromptType } from '../types/promptAssignments';

export const getAllForCurrentUser = async (): Promise<
  Result<
    PromptAssignments.GetAllForCurrentUserReturnType,
    PromptAssignments.PromptAssignmentsError | null
  >
> => {
  let result: Result<
    PromptAssignments.GetAllForCurrentUserReturnType,
    PromptAssignments.PromptAssignmentsError | null
  > = await toResult(
    httpService.get(PromptAssignments.GET_ALL_FOR_CURRENT_USER_CONFIG, {
      shouldReturnMetadata: true
    }),
    PromptAssignments.PromptAssignmentsError
  );
  if (result.isError) {
    return result;
  }

  // Filter prompt types that are not explicitly part of the return value enum
  // we've defined (this is basically a minor validation to ignore prompt types
  // on the back-end that are still in development).
  result = {
    ...result,
    value: result.value.filter(value => Object.values(PromptType).includes(value.promptType))
  };
  return result;
};

export const updateForCurrentUser = (
  action: PromptAssignments.UpdateAction,
  promptType: PromptAssignments.PromptType
): Promise<
  Result<
    PromptAssignments.UpdateForCurrentUserReturnType,
    PromptAssignments.PromptAssignmentsError | null
  >
> =>
  toResult(
    httpService.post(PromptAssignments.UPDATE_FOR_CURRENT_USER_CONFIG, { action, promptType }),
    PromptAssignments.PromptAssignmentsError
  );
